/* eslint-disable prettier/prettier */
import { styleDefinitions } from "./widgets/styles";
// import { footerFunction } from "./widgets/footer";
// import { headerFunction } from "./widgets/header";
import { policyHeader } from "./widgets/policyHeader.js";
import { allgemeineVertragsangaben } from "./widgets/allgemeineVertragsangaben";
import { versicherungsumfang } from "./widgets/versicherungsumfang";
import { selectedProducts } from "./widgets/selectedProducts";
import { vertragsgrundlagen } from "./widgets/vertragsgrundlagen";
import { widerrufsbelehrung, wbEnde } from "./widgets/widerrufsbelehrung";
import { beitragsberechnungHeader, beitragsberechnungTabelle, beitragsberechnungFooter } from "./widgets/beitragsberechnung";
import { beitragsabrechnungHeader, beitragsabrechnungTabelle, beitragsabrechnungFooter } from "./widgets/beitragsabrechnung";
import { finaleHinweise } from "./widgets/finaleHinweise";
import { signatures } from "./widgets/signatures";
import { mandatoryObject } from "./widgets/wbChapter2";

export const documentDefinition = {
  pageSize: 'A4',
  // by default we use portrait, you can change it to landscape if you wish
  pageOrientation: 'portrait',
  // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
  pageMargins: [56.75, 101.7, 56.75, 131.7],
  // PDF Metadaten
  info: {
    title: 'Versicherungspolice',
    author: 'Öffentliche Versicherung Braunschweig',
    subject: 'Versicherungspolice',
    keywords: 'Versicherung, Police, Partner: __partner_id__',
    creator: '4gewinnt',
    producer: 'pdfmake'
  },
  // header: headerFunction,
  content: [
    policyHeader,
    allgemeineVertragsangaben,
    versicherungsumfang,
    selectedProducts,
    vertragsgrundlagen,
    widerrufsbelehrung,
    { ol: mandatoryObject, style: 'regularOptions' },
    wbEnde,
    beitragsberechnungHeader,
    beitragsberechnungTabelle,
    beitragsberechnungFooter,
    beitragsabrechnungHeader,
    beitragsabrechnungTabelle,
    beitragsabrechnungFooter,
    finaleHinweise,
    signatures
  ],
  // footer: footerFunction,
  styles: styleDefinitions,
  defaultStyle: {
    // alignment: 'justify'
    font: "Brix",
    color: "#6a7071",
  }
};
